"use client";

import { useState } from "react";
import { observer } from "mobx-react-lite";
import { createRootStore } from "../mobx/create";
import { RootStoreContext } from "./context";
import type { RootCreationData } from "../mobx/root";

interface RootStoreProviderProps {
  rootCreationData: RootCreationData;
}

const RootStoreProvider: React.FC<
  React.PropsWithChildren<RootStoreProviderProps>
> = observer(({ rootCreationData, children }) => {
  const [root] = useState(() => createRootStore(rootCreationData));

  return (
    <RootStoreContext.Provider value={root}>
      {children}
    </RootStoreContext.Provider>
  );
});

RootStoreProvider.displayName = "RootStoreProvider";

export default RootStoreProvider;
